import Button from '/react4xp/components/prototype/Button'
import ArrowRight from '/react4xp/components/prototype/icons/ArrowRight'
import ArrowUpRight from '/react4xp/components/prototype/icons/ArrowUpRight'

import type { NoEventsBoxProps } from './types'

export default function NoEventsBox({
	heading = 'No events happening right now, subscribe to our newsletter to stay updated.',
	description = 'This section only shows when no events are present. Description of newsletter lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
	ctaLink,
}: NoEventsBoxProps) {
	return (
		<div className="bg-brand-50 py-8 px-3">
			<div className="max-w-400 mx-auto flex flex-col items-center text-center gap-6">
				<svg
					width="128"
					height="128"
					viewBox="0 0 128 128"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
					className="size-32 shrink-0"
				>
					<path
						d="M122.665 64.0002C122.665 96.401 96.3995 122.667 63.9987 122.667C31.5979 122.667 5.33203 96.401 5.33203 64.0002C5.33203 31.5994 31.5979 5.3335 63.9987 5.3335C96.3995 5.3335 122.665 31.5994 122.665 64.0002Z"
						stroke="#C49FD5"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path d="M40 45.3335V50.6668" stroke="#250F24" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M88 45.3335V50.6668" stroke="#250F24" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
					<path
						d="M85.3307 93.3333C85.3307 81.5512 75.7795 72 63.9974 72C52.2153 72 42.6641 81.5512 42.6641 93.3333"
						stroke="#250F24"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<h2 className="h2 text-black-950 max-w-200">{heading}</h2>

				<p className="body text-black-950 max-w-200 text-base">{description}</p>

				{ctaLink?.url && (
					<Button variant="primary" size="lg" href={ctaLink.url} isExternal={ctaLink.isExternal}>
						{ctaLink.text}
						{ctaLink.isExternal ? (
							<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
						) : (
							<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
						)}
					</Button>
				)}
			</div>
		</div>
	)
}
